import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import MenuSectionsContainer from './MenuSectionsContainer';
import { MenuContent, Overlay, TransitionGroupContainer } from './styles';

export default class SideMenu extends Component {
  static propTypes = {
    closeMenu: PropTypes.func.isRequired,
    onClickLogin: PropTypes.func.isRequired,
    onClickLogout: PropTypes.func.isRequired,
    showSmallHeaderMenu: PropTypes.bool.isRequired,
    userData: ImmutablePropTypes.map,
    userLoggedIn: PropTypes.bool.isRequired,
    username: PropTypes.string,
    userAvatarUrl: PropTypes.string,
  };

  state = {
    overlayTop: '70px',
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = event => {
    const target = event.srcElement || event.target;
    // this makes sure we cover all browsers
    const scrollTop =
      window.pageYOffset || target.body.scrollTop || target.documentElement.scrollTop;
    const itemTranslate = Math.max(0, 70 - scrollTop);
    this.setState({
      overlayTop: itemTranslate + 'px',
    });
  };

  render() {
    return (
      <TransitionGroupContainer>
        <TransitionGroup>
          {this.props.showSmallHeaderMenu ? (
            <CSSTransition
              classNames={{
                appear: 'fadeIn',
                appearActive: 'fadeInActive',
                enter: 'fadeIn',
                enterActive: 'fadeInActive',
                exit: 'fadeOut',
                exitActive: 'fadeOutActive',
              }}
              appear={true}
              exit={true}
              timeout={500}
            >
              <Overlay top={this.state.overlayTop} />
            </CSSTransition>
          ) : null}
          {this.props.showSmallHeaderMenu ? (
            <CSSTransition
              classNames={{
                appear: 'slideLeft',
                appearActive: 'slideLeftActive',
                enter: 'slideLeft',
                enterActive: 'slideLeftActive',
                exit: 'slideRight',
                exitActive: 'slideRightActive',
              }}
              appear={true}
              exit={true}
              timeout={500}
            >
              <MenuContent>
                <MenuSectionsContainer
                  closeMenu={this.props.closeMenu}
                  onClickLogin={this.props.onClickLogin}
                  onClickLogout={this.props.onClickLogout}
                  outsideClickIgnoreClass="sideMenuTrigger"
                  userAvatarUrl={this.props.userAvatarUrl}
                  userData={this.props.userData}
                  username={this.props.username}
                  userLoggedIn={this.props.userLoggedIn}
                />
              </MenuContent>
            </CSSTransition>
          ) : null}
        </TransitionGroup>
      </TransitionGroupContainer>
    );
  }
}
